import ImageSnippet from './ImageSnippet';

export default ImageSnippet;
